// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

.golden-rod {
  border-radius: 10px;
  background-color: #FEBF31;
  height: auto;
  margin-bottom: 20px;
  padding: 10px;
  width: 100%;
}
.golden-rod .headline {
  font-size: large;
  font-weight: 700;
}
.golden-rod .body {
  font-size: medium;
  font-weight: 300;
}
.golden-rod .survey-content {
  align-items: center;
  display: flex;
  flex-direction: row;
  font-weight: 500;
  gap: 20px;
}
.golden-rod .survey-content p {
  flex: 1;
  margin: 0;
}
.golden-rod .survey-content .survey-button {
  border-radius: 5px;
  background-color: #0669B3;
  color: #fff;
  display: inline-block;
  font-size: small;
  font-weight: 600;
  padding: 10px 20px;
  text-decoration: none;
  white-space: nowrap;
}
.golden-rod .survey-content .survey-button:hover {
  background-color: #1786DB;
}
@media (max-width: 600px) {
  .golden-rod .survey-content {
    align-items: flex-start;
    flex-direction: column;
  }
  .golden-rod .survey-content .survey-button {
    box-sizing: border-box;
    text-align: center;
    width: 100%;
  }
}

.application-body .golden-rod {
  margin-top: 14px;
  margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/GoldenRod.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;AADA;ECAI,mBDCmC;EACnC,yBDkBQ;ECjBR,YAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;AAIJ;AAFI;EACI,gBAAA;EACA,gBAAA;AAIR;AADI;EACI,iBAAA;EACA,gBAAA;AAGR;AAAI;EACI,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;AAER;AAAQ;EACI,OAAA;EACA,SAAA;AAEZ;AACQ;EC9BJ,kBD+B2C;EACnC,yBDFC;ECGD,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;AACZ;AACY;EACI,yBDXG;ACYnB;AAGQ;EA5BJ;IA6BQ,uBAAA;IACA,sBAAA;EAAV;EAEU;IACI,sBAAA;IACA,kBAAA;IACA,WAAA;EAAd;AACF;;AAKA;EACI,gBAAA;EACA,gBAAA;AAFJ","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
